import React, { useEffect, useState } from "react";
import { Button, List, ListItem, ListItemText, ListItemSecondaryAction, IconButton, Typography, Chip, Alert, SvgIcon, Modal, Box, AlertColor } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Done as DoneIcon, Clear as ClearIcon, ArrowBack } from "@mui/icons-material";
import { SessionInfo} from "../../data/SessionData";
import "./Event.css";
import SaveAdminSessionModal from "./SaveAdminSessionModal";
import { UserInfo } from "../../data/userInfo";
import { getUsers } from "../../services/UserInfo";
import { useGlobal } from "../../utils/GlobalContext";
import { getEventById } from "../../services/EventInformation";
import { newEventInfo } from "../../data/eventInfo";
import ErrorIcon from "@mui/icons-material/Error";
import CheckIcon from "@mui/icons-material/Check";
import { deleteUserSession, updateUserSession } from "../../services/userSessionInformation";


interface EventSessionProps {
    sessionInfo: SessionInfo[];
    eventId: String;
    onEventSessionsUpdate: () => void;
    onBackButtonClick: () => void;
    listUsers: UserInfo [];
}
 
export default function EventSessionListPage({sessionInfo, onBackButtonClick, eventId, onEventSessionsUpdate, listUsers} : EventSessionProps) {
  const [sessions, setSessions] = useState<SessionInfo[]>(sessionInfo);
  const [filter, setFilter] = useState("All");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [sessionToEdit, setSessionToEdit] = useState<SessionInfo | null>(null);
  const [newAdminSession, setNewAdminSession] = useState<SessionInfo | null>(null);
  const { state, dispatch } = useGlobal();
  const CurrentEventId = String(eventId);
  const [usersInfo, setUsersInfo] = useState<UserInfo[]>([]);
  const [currentEvent, setCurrentEvent] = useState(newEventInfo());
  const [isShowAlertSave, setShowAlertSave] = useState(false); //Success Alert
  const [showAlert, setShowAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false); //Error Alert
  const [alertType, setAlertType] = useState<AlertColor>('error');
  const [alertMessage, setAlertMessage] = useState("");

  
  useEffect(() => {
    setUsersInfo(listUsers);
  }, [listUsers]);

    useEffect(() => {
      const fetchEventInfo = async () => {
        try {
          const event = await getEventById(CurrentEventId);
          setCurrentEvent(event);
        } catch (error) {
          console.error("Error fetching event info:", error);
        }
      };
    
      fetchEventInfo(); // Call the function
    }, [CurrentEventId]); // Add dependency array
    
    //delete this later
    console.log(sessions);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

 
  const handleDeleteSession = async (session: SessionInfo) => {
    try
    {
      const askConfirmation = window.confirm("Are you sure you want to delete this session?");
      if (!askConfirmation) {
        return; //User cancels deletion
      }
 
      const delResponse = await deleteUserSession(session, session.UserId);
      if (delResponse === null) {
        setAlertType('error');
        setAlertMessage('Failed to delete session.');
        setShowAlertSave(true);
        setTimeout(() => {
          setShowAlertSave(false);
        }, 5000);
        return;
      }
      console.log(delResponse);
      setSessions((currentSessions: any[]) => currentSessions.filter((s) => s.Id !== session.Id));
    } catch (error: any) {
      console.error("Error deleting this user's session:", error);
      setAlertType('error');
      setAlertMessage('Failed to delete session information:' + error.message);
      setShowAlertSave(true);
      setTimeout(() => {
        setShowAlertSave(false);
      }, 5000);
    }
  };
 
  const handleEditSession = (session: SessionInfo) => {
    setSessionToEdit(session);
    setEditModalOpen(true);
  };

const handleAddSession = () => {
  const currentUser = usersInfo.find((user) => user.Id === state.UserProfile.Id);
  if (!currentUser) {
    // Handle error case where current user is not found in usersInfo
    return;
  }

  const updatedUserSession = {
    ...newAdminSession!,
    UserId: state.UserProfile.Id,
    EventId: CurrentEventId,
    SessionSpeakers: [
      {
        UserId: currentUser.Id || "",
        SpeakerEmail: currentUser.Email || "",
        FirstName: currentUser.FirstName || "",
        LastName: currentUser.LastName || "",
        SpeakerName: `${currentUser.FirstName || ""} ${currentUser.LastName || ""}`,
        PictureLink: currentUser.PictureLink || null,
        SpeakerResponseStatus: 3,
       // Assuming default status is Accepted (3)
      },
    ], 
  };
  console.log("This has the speaker request set");
  console.log(updatedUserSession);
  setSessionToEdit(updatedUserSession);
  setEditModalOpen(true);
  setNewAdminSession(updatedUserSession);
};

const handleSaveSession = async (updatedSession: SessionInfo) => {
  console.log("Updated session: ", updatedSession);
  
  try {
    const response = await updateUserSession(updatedSession, updatedSession.UserId);
    console.log(response);

    // Update the sessionInfo prop
    onEventSessionsUpdate(); // Remove the argument from here
    setShowAlertSave(true);
    setTimeout(() => {
      setShowAlertSave(false);
    }, 5000);
  } catch (error) {
    setErrorMessage(true);
      setTimeout(() => {
        setShowAlertSave(false);
      }, 5000);
    console.error("Failed to update session:", error);
  }


};


  const getSessionStatusChip = (isSelected: boolean) => {
    if (isSelected) {
      return windowWidth < 800
        ? { Icon: DoneIcon, backgroundColor: "green", color: "white" }
        : {
          label: "Accepted",
          Icon: DoneIcon,
          backgroundColor: "green",
          color: "white",
        };
    } else {
      return windowWidth < 800
        ? { Icon: ClearIcon, backgroundColor: "red", color: "white" }
        : {
          label: "Not Approved",
          Icon: ClearIcon,
          backgroundColor: "red",
          color: "white",
        };
    }
  };
 
  const filteredSessions = sessions.filter((session) => {
    if (filter === "Approved") {
        return session.IsSelected === true;
    }
    else if (filter === "Denied") {
        return session.IsSelected === false;
    } else {
        return true;
    }
  });
 
  return  (
    <div style={{ marginBottom: "40px" }}>
      <IconButton onClick={onBackButtonClick} aria-label="back" style={{ marginBottom: "20px" }}>
        <ArrowBack />
      </IconButton>
      <div style={{ marginTop: "20px", marginBottom: "10px" }}>
        {["All", "Approved", "Denied"].map(f => (
          <Button
            key={f}
            variant={filter === f ? "contained" : "outlined"}
            onClick={() => setFilter(f)}
            style={{ marginRight: "8px" }}
          >
            {f}
          </Button>
        ))}
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Button variant="contained" color="primary" onClick={handleAddSession}>
          Add New Session
        </Button>
        <div>
          {isShowAlertSave && (
            <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
              User Session successfully submitted.
            </Alert>
          )}
          {errorMessage && (
            <Alert icon={<ErrorIcon fontSize="inherit" />} severity="error">
              Error saving User Session.
            </Alert>
          )}
        </div>
        <div>
          {showAlert && (
            <Alert
              icon={alertType === 'success' ? <CheckIcon fontSize="inherit" /> : <ErrorIcon fontSize="inherit" />}
              severity={alertType}
            >
              {alertMessage}
            </Alert>
          )}
        </div>
        

      </div>
      <List>
        {filteredSessions.map(session => {
          const { label:SessionLabel, Icon: SessionIcon, backgroundColor:SessionBackground } = getSessionStatusChip(session.IsSelected);
          return (
            <ListItem key={session.Id} divider style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", marginRight: "10px" }}>
                <ListItemText
                  primary={<Typography variant="h6" style={{ fontWeight: 'bold' }}>{session.Title}</Typography>}
                  secondary={
                    <div style={{ display: "flex", flexWrap: windowWidth < 800 ? "wrap" : "nowrap" }}>
                        {session.SessionSpeakers.map((speaker, index) => (
                            <div key={index} style={{ position: "relative" }}>
                                <img
                                    src={speaker.PictureLink || ""}
                                    alt={`${speaker.FirstName} ${speaker.LastName}`}
                                    title={`${speaker.FirstName} ${speaker.LastName}`}
                                    style={{ maxWidth: "30px", maxHeight: "30px", margin: "5px", borderRadius: "50%" }}
                                />
                                <span style={{ position: "absolute", top: "100%", left: "50%", transform: "translateX(-50%)", backgroundColor: "rgba(0, 0, 0, 0.8)", color: "white", padding: "2px 4px", borderRadius: "4px", whiteSpace: "nowrap", opacity: 0, transition: "opacity 0.3s" }}>{`${speaker.FirstName} ${speaker.LastName}`}</span>
                            </div>
                        ))}
                    </div>
                    }
                  style={{ marginRight: "10px", cursor: "pointer" }}
                />
                    <div className="session-chip">
                      {windowWidth >= 800 ? (
                        <Chip
                          icon={SessionIcon ? <SessionIcon /> : undefined}
                          label={
                            <Typography style={{ color: "white" }}>
                              {SessionLabel}
                            </Typography> 
                          }       
                          style={{ backgroundColor: SessionBackground }}
                        />       
                      ) : (
                        <div>
                          <SvgIcon
                            component={SessionIcon}
                            className="session-svg-icon"
                            style={{
                              backgroundColor: SessionBackground,
                              height: "40px",
                              width: "40px",
                              padding: "7px",
                            }}
                          />
                        </div>
                     )}  
                    </div>
              </div>
              <ListItemSecondaryAction style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: "20px" }}>
                <IconButton edge="end" aria-label="edit" onClick={() => handleEditSession(session)}>
                  <EditIcon />
                </IconButton>
                <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteSession(session)}>
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>

   
    {editModalOpen && sessionToEdit && (
      <SaveAdminSessionModal
        session={sessionToEdit}
        usersInfo={usersInfo}
        currentEvent={currentEvent}
        isOpen={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        onSave={handleSaveSession}
      />
    )}
    </div>
  ); 
}